import React, { useEffect, useState } from "react";

const emptyGuest = () => ({ name: "", email: "", phone: "" });

const GuestSubmitForm = ({
  onSubmit,
  loading,
  error,
  title = "Enter Guests",
  phoneRequired = false,
  addButtonLabel = "+ Add Guest",
  resetSignal = 0,
}) => {
  const [guests, setGuests] = useState([emptyGuest()]);

  useEffect(() => {
    setGuests([emptyGuest()]);
  }, [resetSignal]);

  const updateGuest = (index, field, value) => {
    setGuests((prev) =>
      prev.map((g, i) => (i === index ? { ...g, [field]: value } : g))
    );
  };

  const addGuest = () => setGuests((prev) => [...prev, emptyGuest()]);

  const removeGuest = (index) =>
    setGuests((prev) => prev.filter((_, i) => i !== index));

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(guests);
  };

  return (
    <form className="inviteflow-guest-form" onSubmit={handleSubmit}>
      <h3 className="inviteflow-guest-form__title">{title}</h3>
      {error && <p className="inviteflow-guest-form__error">{error}</p>}

      {guests.map((guest, idx) => (
        <div key={idx} className="inviteflow-guest-form__row">
          <span className="inviteflow-guest-form__index">#{idx + 1}</span>
          <input
            type="text"
            placeholder="Full Name"
            value={guest.name}
            onChange={(e) => updateGuest(idx, "name", e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Email"
            value={guest.email}
            onChange={(e) => updateGuest(idx, "email", e.target.value)}
            required
          />
          <input
            type="tel"
            placeholder={phoneRequired ? "Phone" : "Phone (optional)"}
            value={guest.phone}
            onChange={(e) => updateGuest(idx, "phone", e.target.value)}
            required={phoneRequired}
          />
          {guests.length > 1 && (
            <button
              type="button"
              className="inviteflow-btn inviteflow-btn--remove"
              onClick={() => removeGuest(idx)}
            >
              ✕
            </button>
          )}
        </div>
      ))}

      <div className="inviteflow-guest-form__footer">
        <button
          type="button"
          className="inviteflow-btn inviteflow-btn--secondary"
          onClick={addGuest}
        >
          {addButtonLabel}
        </button>
        <button
          type="submit"
          className="inviteflow-btn inviteflow-btn--primary"
          disabled={loading}
        >
          {loading ? "Submitting…" : `Submit ${guests.length} Guest${guests.length > 1 ? "s" : ""}`}
        </button>
      </div>
    </form>
  );
};

export default GuestSubmitForm;
